import './interventionReports.css';
import { Trans } from 'react-i18next';
import FilterIcon from '../../assets/filter.png';
import ModalComponent from '../../component/modal/modal';
import { FC, useState } from 'react';
import { useResponsiveLayout } from '../../hooks/useResponsiveLayout';
import { InterventionReportsTableFilterProps } from './interventionReports.type';

export const InterventionReportsTableFilter: FC<
  InterventionReportsTableFilterProps
> = (props) => {
  const [filters, _setFilters] = useState();
  const { isTablet } = useResponsiveLayout();

  return (
    <>
      <div
        onClick={() => props.toggleFilterModal(!props.isOpenUserModal)}
        className="filter-container mr-3  mt-1 relative inline-block cursor-pointer"
      >
        <img src={FilterIcon} alt="Settings" className="w-3 h-3" />
      </div>
      <ModalComponent
        open={props.isOpenUserModal}
        shouldCloseOnOutsideClick={true}
        onToggle={() => {}}
        onFooterButton1Click={() => {
          props.handleClearFilters();
        }}
        onFooterButton2Click={() => {
          props.handleApplyFilters(filters);
        }}
        dialogClassName={
          isTablet ? 'sweepTableFilterTablet' : 'top-[190px] w-[600px]'
        }
        title={<Trans i18nKey="userManagement.userFilter.filter" />}
        footerButton1Text={
          <Trans i18nKey="userManagement.userFilter.clearAll" />
        }
        footerButton2Text={<Trans i18nKey="userManagement.userFilter.apply" />}
        onClose={() => props.toggleFilterModal(false)}
        showFooter2Button
        showFooter1Button
        isShowClose
        footerButton1WrapperStyle={isTablet ? 'w-[300px]' : ''}
        footerButton2WrapperStyle={isTablet ? 'w-[300px]' : ''}
      >
        <div className="z-20"></div>
      </ModalComponent>
    </>
  );
};
